/**
 * Inline recording indicator: shown under the in-progress audio block itself
 * (created at record-start). Deliberately has NO controls: Save/Cancel live
 * only in the global RecordingOverlay pill, so there's exactly one control
 * surface (the recording keeps running while scrolling/navigating, so
 * controls must be globally reachable anyway).
 */

import type { EntityID } from '@wovin/core'
import type { Component } from 'solid-js'
import { createEffect, createSignal, onCleanup, Show } from 'solid-js'
import { activeRecording, formatElapsed } from '../audio/recorder'

export const RecordingIndicator: Component<{ blockID?: EntityID }> = (props) => {
	const [now, setNow] = createSignal(Date.now())
	const isRecordingHere = () => activeRecording()?.recordingBlockId === props.blockID

	createEffect(() => {
		if (!isRecordingHere()) return
		const interval = setInterval(() => setNow(Date.now()), 500)
		onCleanup(() => clearInterval(interval))
	})

	return (
		<Show when={isRecordingHere() && activeRecording()}>
			{recording => (
				<div class='flex items-center gap-2 my-1 text-sm text-red-500 opacity-90'>
					<div class='i-ph:record-fill animate-pulse' />
					<span>
						Recording… <span class='font-mono'>{formatElapsed(now() - recording().startedAt)}</span>
					</span>
				</div>
			)}
		</Show>
	)
}
